/* eslint-disable react/no-unknown-property */
import clsx from 'clsx';
import React from 'react';
import { useGlobal } from '@rcg/ui-react';
import useStyles from './useStyles';
import Dictionary from '../../../../utils/dictionary';
import useDictionary from '../../../../hooks/useDictionary';
import TimeDuration, { timeWithLocale } from '../../../../utils/timeFormats';
import layoverFormats from '../../../../utils/layoverFormats';
import listsFormats from '../../../../utils/listsFormats';
import { FLIGHT_SEARCH_TYPE } from '../../../../utils/constants';
import { ReactComponent as DefaultIcon } from '../../../../assets/icons/icon-missing-carrier.svg';

const FlightInformation = ({ flight, expanded, index, flightType }) => {
  const classes = useStyles();
  const {
    renderContent,
    data: { localizedDayjs },
  } = useGlobal();
  const getDictionaryValue = useDictionary(Dictionary);

  const listOfAirlines = (operatingAirlines) => {
    return `${operatingAirlines
      .map((airline, airlineIndex) => {
        return `${airline.name}${airlineIndex !== operatingAirlines.length - 1 ? ', ' : ''}`;
      })
      .join('')}`;
  };

  const getFlightSearchTypeLabel = () => {
    return flightType === FLIGHT_SEARCH_TYPE.DEPARTURE
      ? getDictionaryValue(Dictionary.airDepartingLabel.key)
      : getDictionaryValue(Dictionary.airReturningLabel.key);
  };

  let isCollapsed;
  if (expanded && expanded[index]) {
    isCollapsed = (
      <div className={classes.flightInformation}>
        <div className={clsx(classes.airlineInfo, classes.cardInfo)}>
          <object data={flight.flightIcon} className={classes.flightAirlineLogo} type="image/png">
            <DefaultIcon className={classes.flightAirlineLogo} />
          </object>
          <p className={clsx(classes.expandedDepartingDate, classes.standardLabel)}>
            {getFlightSearchTypeLabel()} -{' '}
            {localizedDayjs(flight.departDate).format('ddd[,] MMM D[,] YYYY')}
          </p>
          <p className={clsx(classes.expandedDepartingDateSmall, classes.standardLabel)}>
            {getFlightSearchTypeLabel()} - <br />
            <span>{localizedDayjs(flight.departDate).format('ddd[,] MMM D[,] YYYY')}</span>
          </p>
        </div>
      </div>
    );
  } else {
    isCollapsed = (
      <div className={classes.flightInformation}>
        <div className={clsx(classes.airlineInfo, classes.cardInfo)}>
          <object data={flight.flightIcon} className={classes.flightAirlineLogo} type="image/png">
            <DefaultIcon className={classes.flightAirlineLogo} />
          </object>
          <div className={classes.flightAirline}>
            <p className={clsx(classes.flightTime, classes.standardLabel)}>
              {timeWithLocale(localizedDayjs, flight.departTime)}&nbsp;—&nbsp;
              {timeWithLocale(localizedDayjs, flight.arrivalTime)}
              &nbsp;
              <span className={classes.layoverDays}>
                {layoverFormats.layoverDays({
                  arrival: flight.arrivalDate,
                  departure: flight.departDate,
                })}
              </span>
            </p>
            <p className={clsx(classes.flightOperator, classes.smallLabel)}>
              {flight.operatingAirlines.length === 1 &&
                getDictionaryValue(Dictionary.airOperatorLabel.key)}{' '}
              {listOfAirlines(flight.operatingAirlines)}
            </p>
          </div>
          <div className={classes.flightAirlineSmall}>
            <p className={clsx(classes.flightTimeSmall, classes.standardLabel)}>
              {timeWithLocale(localizedDayjs, flight.departTime)}&nbsp;—&nbsp;
              {timeWithLocale(localizedDayjs, flight.arrivalTime)}
              &nbsp;
              <span className={classes.layoverDays}>
                {layoverFormats.layoverDays({
                  arrival: flight.arrivalDate,
                  departure: flight.departDate,
                })}
              </span>
            </p>
            <p className={clsx(classes.flightItineraryDuration, classes.smallLabel)}>
              {`${flight.flightSegments[0].departure.airport.code} — ${TimeDuration(
                flight.totalDurationMins,
              )} — ${flight.flightSegments[flight.flightSegments.length - 1].arrival.airport.code}`}
            </p>
            <p className={clsx(classes.flightOperatorType, classes.smallLabel)}>
              <span className={classes.typeSmall}>
                {listsFormats.numberOfStops(flight.flightSegments, renderContent)}
                {listsFormats.countStopsLabel(flight.flightSegments)}
              </span>
              <span className={classes.typeMedium}>
                {listsFormats.numberOfStops(flight.flightSegments, renderContent)}
                {listsFormats.countStopsLabel(flight.flightSegments)}
                &nbsp;•&nbsp;
              </span>
              {flight.operatingAirlines.length === 1 &&
                getDictionaryValue(Dictionary.airOperatorLabel.key)}{' '}
              {listOfAirlines(flight.operatingAirlines)}
            </p>
          </div>
        </div>
        <div className={clsx(classes.itineraryInfo, classes.cardInfo)}>
          <p className={clsx(classes.flightDuration, classes.standardLabel)}>
            {TimeDuration(flight.totalDurationMins)}
          </p>
          <p className={clsx(classes.flightItinerary, classes.smallLabel)}>
            {`${flight.flightSegments[0].departure.airport.code} — ${
              flight.flightSegments[flight.flightSegments.length - 1].arrival.airport.code
            }`}
          </p>
        </div>
        <div className={clsx(classes.typeInfo, classes.cardInfo)}>
          <p className={clsx(classes.flightType, classes.standardLabel)}>
            {listsFormats.numberOfStops(flight.flightSegments, renderContent)}
          </p>
          <p className={classes.smallLabel}>{listsFormats.countStopsLabelBig(flight)}</p>
        </div>
      </div>
    );
  }

  return <>{isCollapsed}</>;
};

export default FlightInformation;
